import { create } from 'zustand';
export const useDownloadStateStore = create()((set, get) => ({
    map: {},
    setDownloadDetails: (id, details) => set((state) => ({
        activeTasks: state.activeTasks,
        map: {
            ...state.map,
            [id]: {
                ...state.map[id],
                ...details,
            },
        },
    })),
    getDownloadDetails: (item) => {
        return get().map[item.id.toString()];
    },
    activeTasks: [],
    addTask: (task) => set((state) => {
        const isActive = state.activeTasks.some((existingTask) => {
            return existingTask.id === task.id;
        });
        if (!isActive) {
            state.activeTasks.push(task);
        }
        return state;
    }),
    removeTask: (task) => set((state) => {
        const tasks = state.activeTasks.filter((activeTask) => {
            return activeTask.id !== task.id;
        });
        state.activeTasks = tasks;
        return state;
    }),
    getTasksForContentId: (id) => {
        const tasks = get().activeTasks.filter((t) => {
            return t.id.startsWith(`${id}:`);
        });
        return tasks;
    },
    stopAndRemoveTasksForContentId: (id) => set((state) => {
        const remainingTasks = state.activeTasks
            .reduce((acc, task) => {
            if (task.id.startsWith(`${id}:`)) {
                task.stop();
            }
            else {
                acc.push(task);
            }
            return acc;
        }, []);
        state.activeTasks = remainingTasks;
        return state;
    }),
}));
//# sourceMappingURL=useDownloadStateStore.js.map